import ReactOnRails from 'react-on-rails';

// Two kinds of "globals" reach components, and they work differently:
//
// 1. Request primitives (PB_SITE, PB_ZONE, ...) are redux store state, seeded
//    per request by rails. Read them via the default export below, never as
//    bare JS globals. Test and prewarm defaults: app/javascript/ssr/base_store.json.
//
// 2. Function registries (PB_FUNCTIONS) are registered on window by the client
//    bundle (global_js/) and cannot live in a serialized store. Read them via
//    pbFunctions below. SSR and jest stub: app/javascript/ssr/client_function_stubs.js.

const getStore = () => {
  const store = ReactOnRails.stores().get('Store')?.getState?.()?.location;
  if (store) {
    return store;
  }
  return {};
};

export const pbFunctions = () => (typeof window === 'undefined' ? {} : window.PB_FUNCTIONS || {});

// Re-reads the store on every call by design: a value cached here outlives the
// request inside an SSR worker and leaks one page's state into the next render.
export default () => {
  const {
    PB_SITE,
    PB_SITE_NAME,
    PB_MODE,
    PB_ZONE,
    PB_TYPE,
    PB_THEME,
    PB_PAGE,
    PB_WILDCARD_BASE,
    PB_WILDCARD,
    PB_FORM_DATA,
    PB_LINK_META,
    PB_VISIBILITY_GROUPS,
    PB_SHINGLE_LINES,
    PB_SHINGLE_COLORS,
    host,
    hostname,
    deviceType,
  } = getStore();

  return {
    PB_SITE,
    PB_SITE_NAME,
    PB_MODE,
    PB_ZONE,
    PB_TYPE,
    PB_THEME,
    PB_PAGE,
    PB_WILDCARD_BASE,
    PB_WILDCARD,
    PB_FORM_DATA,
    PB_LINK_META,
    PB_VISIBILITY_GROUPS,
    PB_SHINGLE_LINES,
    PB_SHINGLE_COLORS,
    host,
    hostname,
    deviceType,
  };
};
